const normalizeLanguage = (language?: string | null) => {
	const normalizedLanguage = String(language || '')
		.toLowerCase()
		.trim();

	if (normalizedLanguage.startsWith('en')) {
		return 'en';
	}

	return 'de';
};

export { normalizeLanguage };
